<p-fieldset legend="Lessons">
    <p-message severity="secondary"><p-button label="Add Lessons" (onClick)="goToAddLessons()"/></p-message>  
    <p class="my-4">
        <p-iftalabel>
            <input pInputText [formControl]="searchQuery" autocomplete="off" fluid/> 
            <label>Search...</label>
        </p-iftalabel>   
        <small id="searchQuery-help">Use Module Code/Course Code to search (min 3 characters)</small>
    </p>
    <p-message severity="warn" class="py-2">⚠️&nbsp;This interface can do a test LTI-launch, no real user infomation will be sent to Tool.</p-message>
    <div class="my-2 py-2">  
        <p-message severity="error" class="pulsate">🚨&nbsp;Since no real user information is sent, Grade service will not work. Please login from RLMS for the full feature experience.</p-message>  
    </div>
    <p class="m-0 pt-4">
                    <p-table selectionMode="single" 
                    [value]="lessons" 
                    size="small" 
                    [loading]="loading()" 
                    stripedRows 
                    showGridlines 
                    [paginator]="true"  
                    [rows]="rows" [tableStyle]="{ 'min-width': '50rem' }" 
                    [rowsPerPageOptions]="[5, 10,50,100,200,500]" 
                    [(selection)]="selectedLesson" 
                    dataKey="id"
                    [lazy]="true" 
                    [totalRecords]="totalRecords()" 
                    (onLazyLoad)="onLazyLoad($event)"
                    [first]="first">
                        <ng-template #header>
                            <tr>
                                <th pSortableColumn="code" style="width:14.2%">
                                    Code <p-sortIcon field="code"/>
                                </th> 
                                <th>Course URL (For use in RLMS)</th> 
                                <th>Minimum Passing Marks</th> 
                                <th style="width:10.2%" pSortableColumn="createdAt">Created At <p-sortIcon field="createdAt"/></th>
                                <th style="width:10.2%" pSortableColumn="updatedAt">Updated At <p-sortIcon field="updatedAt"/></th>

                                 <th style="width:9.2%">Is Course Already Deeplinked</th>
                                <th style="width:10%">Deeplink</th>
                                <th style="width:6%">Test Launch</th>
                                <th style="width:9%">Can send grade to RLMS ?</th> 
                            </tr>
                        </ng-template>
                        <ng-template #body let-lesson>
                            <tr [pSelectableRow]="lesson">
                                <td>{{ lesson.code }}</td>
                                <td>@if (lesson.isLessonAlreadyDeeplinked) {
                                    {{ apiURL+lesson.code }}&nbsp;&nbsp;<i class="pi pi-copy text-grey-500" (click)="copyCourseURL(lesson.code)"></i>
                                } @else{
                                   <div class="greyItalicText">Not deeplinked yet.</div>
                                } 
                               </td>
                                <td>{{ lesson.passingMarks }}</td>
                                <td>{{ lesson.createdAt | date}}</td>
                                <td>{{ lesson.updatedAt | date}}</td>
                                <td>
                                    @if (lesson.isLessonAlreadyDeeplinked) {
                                        <i class="pi pi-check text-green-500"></i>
                                    } @else {
                                        <i class="pi pi-times text-red-500"></i>
                                    }
                                </td>
                                <td><p-button
                                type="button"
                                icon="pi pi-link"
                                (click)="initiateDeeplink(lesson.code)"
                                severity="contrast"
                                /></td>
                                <td>
                                 @if (lesson.isLessonAlreadyDeeplinked) {
                                        <p-button
                                        type="button"
                                        icon="pi pi-window-maximize"
                                        (click)="testLaunch(lesson.code)"
                                        severity="success"
                                        />
                                    } @else {
                                        <div class="greyItalicText">Not deeplinked yet.</div>
                                    }

                                    </td>
                                    <td>
                                        @if (lesson.canPostGradeToRLMS) {
                                          <p-button
                                            type="button"
                                            icon="pi pi-check-circle"
                                            (click)="resetCanPostGradeToRLMS(lesson)"
                                            severity="contrast"
                                            pTooltip="Click to reset."
                                        />
                                        } @else{
                                           <p-button
                                            type="button"
                                            icon="pi pi-circle"
                                            (click)="setCanPostGradeToRLMS(lesson)"
                                            severity="secondary"
                                            pTooltip="Click to set."
                                        />
                                        }
                                    </td>  
                            </tr>
                        </ng-template>
                    </p-table>
                </p>
</p-fieldset>